import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const heroBannerV2 = gql`
  fragment Collection_page_hero_banner_v2 on Collection_pageBodyHero_banner_v2 {
    type
    variation {
      ... on Collection_pageBodyHero_banner_v2Default {
        primary {
          title
          paragraph
          button_label
          button_link {
            ...externalLink
            ...documentLink
          }
          sale_type
          sale_percentage
          sale_percentage_text
          sale_items
          sale_banner_color
          sale_banner_link {
            ...documentLink
          }
          banner_bg_image
        }
      }
    }
  }
  ${documentLink}
  ${externalLink}
`;
